<!-- Breadcrumb Section -->
<div class="bg-header" *ngIf="configurationService.isTabletOrLarger$ | async">
  <div class="container-header">
    <div class="row align-items-center mb-2">
      <div class="col-12 col-sm">
        <h1>{{ 'myWorkModule.myWork' | translate }}</h1>
      </div>

      <div
        class="col-12 col-sm-auto justify-content-end overflow-auto hide-scrollbar"
      >
        <nav
          class="btn-group btn-group-toggle w-100 w-md-auto"
          data-toggle="buttons"
          attr.aria-label="{{ 'wcag.myWorkMenu' | translate }}"
          role="tablist"
        >
          <button
            type="button"
            (mouseout)="isMouseOverCalendar = false"
            (mouseover)="isMouseOverCalendar = true"
            [ngClass]="{ active: activeTab == 'calendar' }"
            (click)="activeTab = 'calendar'"
            class="btn btn-soft-secondary text-nowrap"
            [routerLink]="appRoutesNS.MyWork.MY_WORK"
            routerLinkActive="active"
            #rla="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: true }"
            data-test-id="my-work-calendar-tab"
            role="tab"
            [attr.aria-selected]="activeTab == 'calendar' ? 'true' : 'false'"
          >
            <i class="fa fa-calendar-alt" aria-hidden="true" role="img"></i>
            {{ 'general.calendar' | translate }}
          </button>

          <button
            type="button"
            *ngIf="
              employeeModuleConfig.isActive &&
              employeeModuleConfig.showContractDetails
            "
            (mouseout)="isMouseOverContract = false"
            (mouseover)="isMouseOverContract = true"
            [ngClass]="{ active: activeTab == 'contracts' }"
            class="btn btn-soft-secondary text-nowrap"
            (click)="activeTab = 'contracts'"
            [routerLink]="appRoutesNS.MyWork.MY_WORK_EMPLOYEE_CONTRACTS"
            routerLinkActive="active"
            #rla="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: true }"
            data-test-id="my-work-contract-details-tab"
            role="tab"
            [attr.aria-selected]="activeTab == 'contracts' ? 'true' : 'false'"
          >
            <i class="fa fa-list" aria-hidden="true" role="img"></i>
            {{ 'employeeModule.contractDetails' | translate }}
          </button>

          <button
            type="button"
            *ngIf="
              employeeModuleConfig.isActive && employeeModuleConfig.showInvoice
            "
            (mouseout)="isMouseOverInvoice = false"
            (mouseover)="isMouseOverInvoice = true"
            [ngClass]="{ active: activeTab == 'invoices' }"
            (click)="activeTab = 'invoices'"
            class="btn btn-soft-secondary text-nowrap"
            [routerLink]="appRoutesNS.MyWork.MY_WORK_INVOICES"
            routerLinkActive="active"
            #rla="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: true }"
            data-test-id="my-work-invoice-tab"
            role="tab"
            [attr.aria-selected]="activeTab == 'invoices' ? 'true' : 'false'"
          >
            <i class="fa fa-file-alt" aria-hidden="true" role="img"></i>
            {{ 'employeeModule.invoice' | translate }}
          </button>

          <button
            type="button"
            *ngIf="supervisorModuleConfig.isActive"
            (mouseout)="isMouseOverSuprevisorBookings = false"
            (mouseover)="isMouseOverSuprevisorBookings = true"
            [ngClass]="{ active: activeTab == 'supervisorBookings' }"
            (click)="activeTab = 'supervisorBookings'"
            class="btn btn-soft-secondary text-nowrap"
            [routerLink]="appRoutesNS.MyWork.MY_WORK_SUPERVISOR_BOOKINGS"
            routerLinkActive="active"
            data-test-id="my-work-invites-tab"
            [routerLinkActiveOptions]="{ exact: true }"
            #rla="routerLinkActive"
          >
            <i class="fa fa-comment-alt" aria-hidden="true" role="img"></i>
            {{ 'myWorkModule.supervisorInvites' | translate }}
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>

<nav
  attr.aria-label="{{ 'wcag.myWorkMenu' | translate }}"
  class="bg-white"
  *ngIf="!(configurationService.isTabletOrLarger$ | async)"
  role="tablist"
>
  <ul
    class="nav nav-underline flex-nowrap border-bottom overflow-auto hide-scrollbar gap-2"
  >
    <li class="nav-item flex-fill text-center">
      <button
        type="button"
        (mouseout)="isMouseOverCalendar = false"
        (mouseover)="isMouseOverCalendar = true"
        [ngClass]="{ active: activeTab == 'calendar' }"
        (click)="activeTab = 'calendar'"
        class="nav-link text-nowrap px-2 py-3 w-100"
        [routerLink]="appRoutesNS.MyWork.MY_WORK"
        routerLinkActive="active"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        data-test-id="my-work-calendar-tab"
        role="tab"
        [attr.aria-selected]="activeTab == 'calendar' ? 'true' : 'false'"
      >
        {{ 'general.calendar' | translate }}
      </button>
    </li>
    <li class="nav-item flex-fill text-center">
      <button
        type="button"
        *ngIf="
          employeeModuleConfig.isActive &&
          employeeModuleConfig.showContractDetails
        "
        (mouseout)="isMouseOverContract = false"
        (mouseover)="isMouseOverContract = true"
        [ngClass]="{ active: activeTab == 'contracts' }"
        class="nav-link text-nowrap px-2 py-3 w-100"
        (click)="activeTab = 'contracts'"
        [routerLink]="appRoutesNS.MyWork.MY_WORK_EMPLOYEE_CONTRACTS"
        routerLinkActive="active"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        data-test-id="my-work-contract-details-tab"
        role="tab"
        [attr.aria-selected]="activeTab == 'contracts' ? 'true' : 'false'"
      >
        {{ 'employeeModule.contractDetails' | translate }}
      </button>
    </li>
    <li class="nav-item flex-fill text-center">
      <button
        type="button"
        *ngIf="
          employeeModuleConfig.isActive && employeeModuleConfig.showInvoice
        "
        (mouseout)="isMouseOverInvoice = false"
        (mouseover)="isMouseOverInvoice = true"
        [ngClass]="{ active: activeTab == 'invoices' }"
        (click)="activeTab = 'invoices'"
        class="nav-link text-nowrap px-2 py-3 w-100"
        [routerLink]="appRoutesNS.MyWork.MY_WORK_INVOICES"
        routerLinkActive="active"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        data-test-id="my-work-invoice-tab"
        role="tab"
        [attr.aria-selected]="activeTab == 'invoices' ? 'true' : 'false'"
      >
        {{ 'employeeModule.invoice' | translate }}
      </button>
    </li>
    <li class="nav-item flex-fill text-center">
      <button
        type="button"
        *ngIf="supervisorModuleConfig.isActive"
        (mouseout)="isMouseOverSuprevisorBookings = false"
        (mouseover)="isMouseOverSuprevisorBookings = true"
        [ngClass]="{ active: activeTab == 'supervisorBookings' }"
        (click)="activeTab = 'supervisorBookings'"
        class="nav-link text-nowrap px-2 py-3 w-100"
        [routerLink]="appRoutesNS.MyWork.MY_WORK_SUPERVISOR_BOOKINGS"
        routerLinkActive="active"
        data-test-id="my-work-invites-tab"
        [routerLinkActiveOptions]="{ exact: true }"
        #rla="routerLinkActive"
        role="tab"
        [attr.aria-selected]="
          activeTab == 'supervisorBookings' ? 'true' : 'false'
        "
      >
        {{ 'myWorkModule.supervisorInvites' | translate }}
      </button>
    </li>
  </ul>
</nav>

<!-- End Breadcrumb Section -->
<div class="container-lg main-container">
  <router-outlet></router-outlet>
</div>
